import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { PetItem } from './common/PetItem';

import { PET_DEMOS_SPECIES } from '../../constants';

import checkGreenIcon from '../../assets/policy/check-green.svg';

import styles from './RolloverSpeciesSection.module.css';

const RolloverSpeciesSection = ({
  list = [],
  maxCount = 0,
  minCount = 0,
  onPetClick = () => { },
  readOnly = false,
  selectedIds = new Set(),
  speciesKey = PET_DEMOS_SPECIES.dog,
}) => {
  const { t } = useTranslation('petDemos');

  if (!list.length) {
    return null;
  }

  // Read-only: pet rolls over automatically
  const selectedInSpecies = readOnly ? list : list.filter((pet) => (
    selectedIds.has(pet.employeeDependentId)
  ));
  const count = selectedInSpecies.length;
  const requiredCount = minCount > 0 ? minCount : maxCount;
  const isComplete = requiredCount > 0 && count >= requiredCount;
  const subInstructionKey = speciesKey === PET_DEMOS_SPECIES.cat
    ? 'reviewRollover.selectCats'
    : 'reviewRollover.selectDogs';
  const speciesLabel = speciesKey === PET_DEMOS_SPECIES.cat
    ? t('reviewRollover.cats') : t('reviewRollover.dogs');

  return (
    <div className={styles.speciesSection}>
      <div className={styles.speciesHeader}>
        <div className={styles.speciesTitleContainer}>
          <h4 className={styles.speciesTitle}>{speciesLabel}</h4>

          <p className={styles.speciesSubInstruction}>
            {t(subInstructionKey)}
          </p>
        </div>

        <div
          className={styles.speciesCounterContainer}
          data-is-complete={isComplete}
        >
          <span className={styles.speciesCounter}>
            <Trans
              i18nKey="reviewRollover.speciesCounter"
              ns="petDemos"
              values={{
                count,
                maxCount,
                species: speciesLabel,
              }}
            />
          </span>

          {isComplete && (
            <img
              alt=""
              className={styles.chipIcon}
              src={checkGreenIcon}
            />
          )}
        </div>
      </div>

      <div className={styles.chipsContainer}>
        {list.map((pet) => {
          const petLabel = pet.demographicData?.petName || '...';
          const isSelected = readOnly
            || selectedIds.has(pet.employeeDependentId);

          return (
            <PetItem
              key={pet.employeeDependentId}
              disabled={readOnly}
              isRolloverModal
              isSelected={isSelected}
              label={petLabel}
              onClick={onPetClick(pet)}
              specie={pet.demographicData?.species || PET_DEMOS_SPECIES.dog}
            />
          );
        })}
      </div>
    </div>
  );
};

export { RolloverSpeciesSection };
